import { SpecialHispanic } from "./special-hispanic/special-hispanic";
import { PilotoRNBP } from "./piloto-rnbp/piloto-rnbp";

export const Landings = {
    SpecialHispanic,
    PilotoRNBP
}
